export default __webpack_public_path__ + "static/fall20-e604ac0e20d066fe7ae3c07f1cefa367.webp";